"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "spinetoli": {
    "863a8b2c": [{
      "hkey": "1282f51b",
      "slug": "pagliare-del-tronto",
      "name": "Pagliare del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "pagliare": [{
      "hkey": "1282f51b",
      "slug": "pagliare-del-tronto",
      "name": "Pagliare del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "ecc41751": [{
      "hkey": "b9531573",
      "slug": "villa-san-pio-x",
      "name": "Villa San Pio X",
      "primary": true,
      "skipSearch": false
    }],
    "san-pio-x": [{
      "hkey": "b9531573",
      "slug": "villa-san-pio-x",
      "name": "Villa San Pio X",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;